import { AuthenticatedApiClient } from '@guiker/payment-shared'
import { useAuthenticatedApiClient } from '@guiker/react-framework'

export const usePaymentApiClient = useAuthenticatedApiClient(AuthenticatedApiClient)
